import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

interface Props {
  isLoading: boolean;
  handleClick?: () => void;
  isDisabled: boolean;
  isSubmit?: boolean;
  label?: string;
  className?: string;
}

export default function ButtonWithLoading(props: Props) {
  const { t } = useTranslation();
  const {
    isLoading,
    handleClick = () => false,
    isDisabled,
    label = t('global.search'),
    isSubmit = false,
    className = '',
  } = props;

  return (
    <div className={clsx(className, 'relative')}>
      <button
        onClick={handleClick}
        type={isSubmit ? 'submit' : 'button'}
        // disabled={isDisabled || isLoading}
        className={clsx(
          isDisabled || isLoading ? 'cursor-not-allowed' : 'cursor-pointer',
          'bg-primary-yellow text-primary-black rounded-4-0 py-1-0 px-2-0 font-bold  hover:bg-opacity-80 ',
        )}
      >
        <span>{label}</span>
      </button>
    </div>
  );
}
